// extracted by mini-css-extract-plugin
export default {"arrowColor":"#44cc94","arrowColorDisabled":"#808c9c","row":"row__3XRSU","paginationButton":"paginationButton__2L6Fv"};
    if(module.hot) {
      // 1790586298899
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  